import Dexie from 'dexie';

export { liveQuery } from 'dexie';

export default Dexie;
